import { FC } from 'react';
import { CgMathPercent } from 'react-icons/cg';
import { Text } from '@chakra-ui/react';

import {
  convertDecimalToPercentile,
  convertPercentileToDecimal,
  preserveEmpty,
} from '~/core/application/workflow/utils/transformFuncs';
import { WorkflowStepFormFieldNumberInput } from '../types/workflowStepComponentTypes';
import { FieldToBlock, FieldValueProps } from './declarations';
import { commonFieldBlockProps } from './FieldUtils';

export const PercentFieldToBlock: FieldToBlock<
  'percent',
  WorkflowStepFormFieldNumberInput
> = (field) => ({
  ...commonFieldBlockProps(field),
  componentType: 'number-input',
  transformFuncsIn: [convertDecimalToPercentile],
  transformFuncsOut: [preserveEmpty(convertPercentileToDecimal)],
  componentProps: {
    startElement: <CgMathPercent />,
    decimalPlaces: 7,
    size: 'sm',
  },
});

type PercentFieldValueProps = FieldValueProps<'percent'>;

export const PercentFieldValue: FC<PercentFieldValueProps> = ({ field }) => {
  const value = convertDecimalToPercentile(field.value ?? 0);

  return <Text>{value}%</Text>;
};
